import {getApolloClient} from 'graphql-client/ApolloClient';
import {RealtimeMessageType} from 'realtime/Constants';
import {GET_ASSAY_RUN_ANALYSIS_IDS} from 'results/analysis-integration/AnalysisTemplateIntegrationUtils';

import type {DocumentUpdateMessageHandler} from './DocumentUpdateMessageHandlerConstants';

export const analysisStartedMessageHandler: DocumentUpdateMessageHandler<
  typeof RealtimeMessageType.ANALYSIS_STARTED
> = {
  active: () => {
    getApolloClient().refetchQueries({include: [GET_ASSAY_RUN_ANALYSIS_IDS]});
  },
  // The document is in the background, so its run-analysis query is not mounted and refetchQueries
  // would skip it. The message carries no run id, so evict the analysisIds field on every cached run
  // to force a refetch on reopen while leaving the rest of each run's cached data intact.
  inactive: () => {
    const {cache} = getApolloClient();
    Object.keys(cache.extract())
      .filter((cacheId) => cacheId.startsWith('RunNode:'))
      .forEach((cacheId) => cache.evict({id: cacheId, fieldName: 'analysisIds'}));
    cache.gc();
  },
};
